module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-600.9526470.woff2";